/* eslint-disable no-magic-numbers */
/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-useless-return */
/* eslint-disable max-depth */
/* eslint-disable prefer-template */
/* eslint-disable no-return-assign */
/* eslint-disable prefer-const */
/* eslint-disable max-lines */
/* eslint-disable @typescript-eslint/prefer-for-of */
/* eslint-disable max-lines-per-function */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable no-unused-expressions */
/* eslint-disable complexity */
/* eslint-disable @typescript-eslint/prefer-optional-chain */
/* eslint-disable no-var */
/* eslint-disable eqeqeq */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable max-params */
/* eslint-disable @typescript-eslint/array-type */
/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-member-accessibility */
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

export interface FeedbackOption {
    id: string;
    value: string;
    text: string;
    checked?: boolean;
}

export interface FeedbackData {
    selectedOption: string;
    additionalFeedback?: string;
}

@Component({
    selector: 'app-user-feedback',
    templateUrl: './user-feedback.component.html',
    styleUrls: ['./user-feedback.component.scss'],
    standalone: false
})
export class UserFeedbackComponent implements OnInit {
    @Input() feedbackOptions: FeedbackOption[] = [];
    @Output() feedbackChange = new EventEmitter<FeedbackData>();
    @Output() feedbackSubmit = new EventEmitter<FeedbackData>();

    selectedOption: string = '';
    additionalFeedback: string = '';
    showOtherTextarea: boolean = false;

    private defaultOptions: FeedbackOption[] = [
        { id: '1', value: 'inaccurate', text: 'Inaccurate', checked: false },
        { id: '2', value: 'incomplete', text: 'Incomplete', checked: false },
        { id: '3', value: 'needs_additional_info', text: 'Needs additional information', checked: false },
        { id: '4', value: 'other', text: 'Other', checked: false }
    ];

    constructor(public translate: TranslateService) { }

    ngOnInit(): void {
        // Use provided options or default ones
        if (!this.feedbackOptions || this.feedbackOptions.length === 0) {
            this.feedbackOptions = this.defaultOptions;
        }

        // Ensure all options have checked property
        this.feedbackOptions = this.feedbackOptions.map(option => ({
            ...option,
            checked: option.checked || false
        }));
    }

    onOptionChange(selectedOption: FeedbackOption): void {
        // Update checked status for all options
        this.feedbackOptions.forEach(option => {
            option.checked = option.id === selectedOption.id;
        });

        this.selectedOption = selectedOption.value;
        this.showOtherTextarea = selectedOption.value === 'other';

        // Clear additional feedback if not "other" option
        if (!this.showOtherTextarea) {
            this.additionalFeedback = '';
        }

        this.emitFeedbackChange();
    }

    onAdditionalFeedbackChange(): void {
        this.emitFeedbackChange();
    }

    private emitFeedbackChange(): void {
        const feedbackData: FeedbackData = {
            selectedOption: this.selectedOption,
            additionalFeedback: this.additionalFeedback || undefined
        };

        this.feedbackChange.emit(feedbackData);
    }

    submitFeedback(): void {
        if (this.selectedOption) {
            const feedbackData: FeedbackData = {
                selectedOption: this.selectedOption,
                additionalFeedback: this.additionalFeedback || undefined
            };

            this.feedbackSubmit.emit(feedbackData);
        }
    }

    resetFeedback(): void {
        this.selectedOption = '';
        this.additionalFeedback = '';
        this.showOtherTextarea = false;

        // Reset all checked states
        this.feedbackOptions.forEach(option => {
            option.checked = false;
        });

        this.emitFeedbackChange();
    }

    get isValidFeedback(): boolean {
        return this.selectedOption !== '' &&
            (this.selectedOption !== 'other' || this.additionalFeedback.trim() !== '');
    }
}